export const DEFAULT_DATA_FILL_COLOR = "#c8f8e9";
export const DEFAULT_DATA_FONT_COLOR = "black";
export const DEFAULT_HEADERS_FILL_COLOR = "#47d5a8";
export const DEFAULT_EMPTY_CELL_VALUE = "-";
